// extracted by mini-css-extract-plugin
export default {"menuBody":"_3Ar963aF1Fv08Bt3zDwqnc"};